import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Graph } from "../../../models";
import {
  setCurrentNode,
  setEndNode,
  setGameGraph,
  setIsPlaying,
  setIsStarted,
  setIsWon,
  setStartNode,
} from "../../../store/actions";
import {
  currentNodeSelector,
  difficultiesSelector,
  endNodeSelector,
  isStartedSelector,
} from "../../../store/selectors";
import { getExampleGraphJSON, getStartAndEndNodes } from "../../../utils";
import { Button } from "../../shared";
import styles from "./Buttons.module.scss";

const Buttons: React.FC = () => {
  const dispatch = useDispatch();

  const difficulty = useSelector(difficultiesSelector);
  const hasStarted = useSelector(isStartedSelector);
  const currentNode = useSelector(currentNodeSelector);
  const endNode = useSelector(endNodeSelector);

  const handleStartAgain = (): void => {
    startGame();
    dispatch(setIsStarted(true));
    dispatch(setIsPlaying(true));
  };

  const startGame = (): void => {
    const newGraph = Graph.fromJSON(getExampleGraphJSON(10, difficulty * 5));
    const [startNode, endNode] = getStartAndEndNodes(
      newGraph,
      difficulty * 5 + 5
    );
    dispatch(setCurrentNode(startNode));
    dispatch(setGameGraph(newGraph));
    dispatch(setStartNode(startNode));
    dispatch(setEndNode(endNode));
  };

  const handleSubmit = (): void => {
    if (currentNode === endNode) {
      dispatch(setIsWon(true));
    } else {
      alert("Wrong answer,try again");
    }
  };

  return (
    <div className={styles.playMode__container__buttons}>
      <Button
        onClick={handleSubmit}
        className={styles.playMode__container__buttons__submit}
      >
        Submit
      </Button>
      <Button
        onClick={handleStartAgain}
        className={styles.playMode__container__buttons__start}
      >
        {hasStarted ? "Start Again" : "Start"}
      </Button>
      <Link className={styles.goback__link} to="/game">
        <Button className={styles.playMode__container__buttons__goback}>
          Go back
        </Button>
      </Link>
    </div>
  );
};

export default Buttons;
